import React from 'react';

import { ClipboardList } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  caption: {
    color: 'rgba(50, 74, 82, 0.6)',
    display: 'block',
    fontSize: 12,
  },
  iconCircle: {
    alignItems: 'center',
    backgroundColor: 'rgba(20, 110, 232, 0.1)',
    borderRadius: '50%',
    color: theme.appColors.primary,
    display: 'flex',
    flexShrink: 0,
    height: 32,
    justifyContent: 'center',
    width: 32,
  },
  titleGroup: {
    marginRight: 'auto',
    minWidth: 0,
  },
}));

// The icon and "Intake form" caption, matching the workflow summary cards (documents, collaborators).
export function IntakeCardLead({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.iconCircle}>
        <ClipboardList size={16} />
      </div>
      <div className={classes.titleGroup}>
        <span className={classes.caption}>Intake form</span>
        {children}
      </div>
    </>
  );
}
